<template>
    <div class="tw:p-6">
        <h2 class="tw:text-sm tw:font-semibold tw:text-gray-500 tw:uppercase tw:tracking-wide tw:my-1">Desglose por categoría</h2>
        <p class="tw:text-xs tw:text-gray-400 tw:mb-4">Distribución de ventas agrupadas por categoría</p>
        <div v-if="hasData" class="tw:flex tw:items-center tw:justify-start tw:flex-col tw:sm:flex-row tw:gap-2 tw:pt-2">
            <div class="tw:w-full tw:mx-auto">
                <Chart
                    type="PieChart"
                    :data="desglose"
                    :options="chartOptions"
                    :height="190"
                    :loading="false"
                />
            </div>
            <div class="tw:flex tw:w-full tw:flex-col tw:gap-2 tw:px-6 tw:items-center tw:md:items-start">
                <div>
                    <span class="tw:text-xs tw:font-semibold tw:text-gray-500 tw:uppercase tw:tracking-wider">Desglose</span>
                    <div v-for="(item, index) in legendItems" :key="item.categoria" class="tw:flex tw:items-center tw:gap-2">
                        <span
                            class="tw:h-3 tw:w-3 tw:rounded-full tw:shrink-0"
                            :style="{ backgroundColor: chartColors[index] }"
                        ></span>
                        <span class="tw:text-sm tw:text-gray-700">{{ item.categoria }}</span>
                        <span class="tw:text-sm tw:font-semibold tw:text-gray-900">{{ item.total }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div
            v-else
            class="tw:flex tw:justify-center tw:items-center tw:text-gray-400"
            :style="{ height: '200px' }"
        >
            No hay datos de categorías
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import Chart from '@/modules/admin/ui/Chart.vue';

    const CATEGORY_COLORS = [
        '#3b82f6', '#10b981', '#f59e0b', '#ef4444',
        '#8b5cf6', '#ec4899', '#14b8a6', '#f97316',
        '#6366f1', '#84cc16', '#06b6d4', '#d946ef'
    ];

    const props = defineProps({
        desglose: { type: Array, default: () => [] }
    });

    const hasData = computed(() => props.desglose && props.desglose.length > 1);

    const legendItems = computed(() => {
        if (!props.desglose || props.desglose.length < 2) return [];
        const [, ...rows] = props.desglose;
        return rows.map(row => ({
            categoria: row[0],
            total: row[1]
        }));
    });

    const chartColors = computed(() =>
        legendItems.value.map((_, i) => CATEGORY_COLORS[i % CATEGORY_COLORS.length])
    );

    const chartOptions = computed(() => ({
        title: '',
        pieHole: 0.4,
        legend: { position: 'none' },
        colors: chartColors.value,
        height: 200
    }));
</script>
